import React, {useEffect} from 'react'
import NavbarAdmin from '../../components/NavbarAdmin';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import Swal from "sweetalert2";  
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import DataTable from 'react-data-table-component';
import { Dna } from  'react-loader-spinner'
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Container from '@mui/material/Container';
import { Box, TextField,FormControl} from '@mui/material';
import { createTheme} from '@mui/material/styles';


const theme = createTheme({
  palette: {
    mode: 'light',
  },
});


const Prestazioni = () => {
  const [prestazioni, setPrestazioni] = React.useState([]);
  const [search, setSearch] = React.useState("");
  const [isShow, invokeModal] = React.useState(false)
  const [isShowAdd, invokeModalAdd] = React.useState(false)
  const [prestazioneSelected, setPrestazioneSelected] = React.useState({})
  const [selectedTipoMod, setSelectedTipoMod] = React.useState(-1)
  const [comboPrestazioni, setComboPrestazioni] = React.useState([])
  const [pending, setPending] = React.useState(true);
  const [colors, setColors] = React.useState([]);
  const axiosPrivate = useAxiosPrivate();
  const columns = [
    {
      name: '#',
      selector: row => <div style={{width:15,height:15,borderRadius:3,backgroundColor:row.colore,boxShadow:"0 2px 2px rgb(0 0 0 / 0.2)",marginBottom:5,marginRight:5}}></div>,
      sortable: false,
      grow: 0,
    },
    {
      name: 'Prestazione',
      selector: row => row.descrizione,
      sortable: true,
      grow: 2,
    },
    {
      name: 'Traduzione',
      selector: row => row.descrizioneEN,
      sortable: false,
      grow: 2,
    },
    {
      name: 'Tipo di Prestazione',
      selector: row => row.tipo === 1 ? "Servizio" : "Visita",
      sortable: true,
      grow: 1,
    },
    {
      name: '#',
      selector: row =>  
      <div className='d-flex justify-content-end'>
        <IconButton color='primary' onClick={() => openModal(row)}><EditIcon fontSize='22px'/></IconButton>
        <IconButton color='error' onClick={() => handleDeleteAlert(row.idPrestazione)}><DeleteIcon fontSize='22px' /></IconButton>
      </div>,
      sortable: false,
      grow: 1,
      right: true,
    },
  ];


  const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
      padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
      padding: theme.spacing(1),
    },
  }));
  
  function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;
  
    return (
      <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
        {children}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
    );
  }

  
  const paginationComponentOptions = {
    rowsPerPageText: 'Prestazioni per pagina',
    rangeSeparatorText: 'di',
    selectAllRowsItem: true,
    selectAllRowsItemText: 'Tutti',
};
  const openModal = (prestazione) => {
    getComboPrestazioni()
    setPrestazioneSelected(prestazione)
    setSelectedTipoMod(prestazione.tipo)
    return invokeModal(!isShow)
  }
  const handleClose = () => {
    return invokeModal(!isShow)
  }
  const initModalAdd = () => {
    getComboPrestazioni()
    return invokeModalAdd(!isShowAdd)
  }
  const handleAlert = (title,message,type) => {
    Swal.fire({  
      title: title,  
      icon: type,  
      text: message,  
    });  
  }

  const handleDeleteAlert = (idPrestazione) => {
    Swal.fire({
      title: 'Sei sicuro?',
      text: "Non potrai più recuperare questa Prestazione!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Annulla',
      confirmButtonText: 'Si, elimina!'
    }).then((result) => {
      if (result.isConfirmed) {
        handleDelete(idPrestazione)
      }
    })
  }

  const handleDelete = async (idPrestazione) => {
    try {
      let res = await axiosPrivate.post("api/prest/deletePrestazione", {
          idPrestazione: idPrestazione
      });
      if (res.status === 200) {
        handleAlert("Eliminazione prestazione","Prestazione eliminata con successo","success")
       setPrestazioni(prestazioni.filter((prestazione) => prestazione.idPrestazione !== idPrestazione))
      } else if (res.status === 226) {
        handleAlert("Eliminazione prestazione","Errore durante l'eliminazione della Prestazione perchè è in uso","warning")
      }else {
        handleAlert("Eliminazione prestazione","Errore durante l'eliminazione della Prestazione","error")
      }
    } catch (err) {
      console.error(err);
    }
  }


  const handleSearch = async (e) => {
    e.preventDefault();
    try {
      let res = await axiosPrivate.post("api/prest/getPrestazioni", {
          Descrizione: search,
      });
      let data = await res.data;
      if (res.status === 200) {
        setPrestazioni(data);
      } else {
        console.error("Some error occured");
      }
    } catch (err) {
      console.error(err);
    }

  }

  const handleNewPrestazione = async (e) => {
    e.preventDefault();
    
    try {
      let res = await axiosPrivate.post("api/prest/insertPrestazione", {
          descrizione: document.getElementById("prestazione").value,
          descrizioneEN: document.getElementById("prestazioneEN").value,
          tipo: document.getElementById("tipo").value,
          colore: generateUniqueColor(colors)
      });
      let data = await res.data;
      initModalAdd()
      if (res.status === 200) {
        setPrestazioni([data,...prestazioni])
        handleAlert("Inserimento prestazione","Prestazione inserita con successo","success")
      }else{
        handleAlert("Inserimento prestazione","Errore durante l'inserimento della prestazione","error")
      }
    } catch (err) {
      console.error(err);
    }
  }

  const handleModifyPrestazione = async (e) => {
    e.preventDefault();
    try {
      let res = await axiosPrivate.post("api/prest/modifyPrestazione", {
                idPrestazione: prestazioneSelected.idPrestazione,
                descrizione: document.getElementById("prestazioneMod").value,
                descrizioneEN: document.getElementById("prestazioneENMod").value,
                tipo: document.getElementById("tipoMod").value
        });
        let data = await res.data;
        handleClose()
        if (res.status === 200) {
          
          setPrestazioni(prestazioni.map((prestazione) => prestazione.idPrestazione === prestazioneSelected.idPrestazione ? data : prestazione))
          handleAlert("Modifica prestazione","Prestazione modificata con successo","success")
        } else if(res.status === 204) {
          handleAlert("Modifica prestazione","Non posso procedere con la modifica dei dati.","warning")
        }
        else {
          handleAlert("Modifica prestazione","Errore durante la modifica della prestazione","error")
        }
        
    } catch (err) {
        console.error(err);
    }
}
const getComboPrestazioni = async () => {
  let res = await axiosPrivate.get("api/combo/getComboTipiPrestazioni");
  let data = await res.data;
  if (res.status === 200) {
    setComboPrestazioni(data);
  } else {  
    console.error("Some error occured");
  }
}

  useEffect(() => {
    const fetchData = async () => {
      try{
        let res = await axiosPrivate.post("api/prest/getPrestazioni", {
            Descrizione: ""
        });
        let data = await res.data;
        if (res.status === 200) {
          setPrestazioni(data);
          setColors(data.map(item => item.colore))
          setPending(false);
        } else if(res.status === 500) {
          console.error("Some error occured");
        }
      }catch(err){
        console.error(err);
        setPrestazioni([]);
      }
    }

    const getPrestazioni = async () => {
      let res = await axiosPrivate.get("api/combo/getComboTipiPrestazioni");
      let data = await res.data;
      if (res.status === 200) {
        setComboPrestazioni(data);
      } else {  
        console.error("Some error occured");
      }
    }
      fetchData();
      getPrestazioni();
    }, [axiosPrivate]);

    const styles = {
      questionnaireContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        padding: '1rem',
      },
      box: {
          display: 'flex',
          flexDirection: 'column',
        width: '100%',
        maxWidth: '950px',
        borderRadius: '8px',
        backgroundColor: theme.palette.action.hover,
        padding: '2rem',
        boxShadow: '0 3px 5px rgba(0, 0, 0, 0.3)',
        justifyContent: 'space-between',
      },
      boxDate: {
      display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
      },
      boxDownload: {
          height: '70px',
          display: 'flex',
          flexDirection: 'row',
            width: '100%',
            justifyContent: 'flex-end',
            gap: '1rem',
            padding: '0.5rem',
          },
    };

    const handleTranslationFileUpdate = async () => {

        axiosPrivate.post("api/prest/setTranslationFiles").then((res) => {
            if (res.status === 200) {
              handleAlert("Aggiornamento traduzioni","Traduzioni aggiornate con successo","success")
            } else if(res.status === 500) {
              handleAlert("Aggiornamento traduzioni","Errore durante l'aggiornamento delle traduzioni","error")
            }
        }).catch((err) => {
            console.error(err);
        })
    }

    function generateUniqueColor(prevColors) {
      let color = '';
    
      do {
        color = `rgba(${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, 1)`;
      } while (prevColors.includes(color));
    
      return color;
    }
  return (
    <>
    <NavbarAdmin />
    <Container maxWidth="md" sx={styles.questionnaireContainer}>
    <Box sx={{ alignSelf: "start",display:'flex', justifyContent:'space-between',width:'100%',alignItems:'center' }}>
        <h1>Prestazioni</h1> <Button variant="contained" color='secondary' size="lg" onClick={handleTranslationFileUpdate}>Aggiorna traduzioni</Button>
    </Box>
    <Box sx={styles.box}>
      <Box sx={styles.boxDownload} >
        <form onSubmit={handleSearch} style={{ 
          display: 'flex',
          flexDirection: 'row',
            width: '100%',
            justifyContent: 'flex-end',
            gap: '1rem'}}>
          <TextField label="Cerca" variant="outlined" onInput={e => setSearch(e.target.value)}/>
          <Button variant="contained" color='success' size="large" type="submit" value={search} >Cerca</Button>
        </form>
        <Button variant="contained" color='success' size="large" onClick={initModalAdd}><AddIcon /></Button>
      </Box>
      <Box sx={{marginTop:'1rem'}}>
          <DataTable 
          columns={columns} 
          data={prestazioni} 
          pagination
          paginationComponentOptions={paginationComponentOptions}
          highlightOnHover
          striped
          noDataComponent={<div className='text-center my-4 '>Nessuna Prestazione trovata</div>}
          progressPending={pending}
            progressComponent={
            <Dna
              visible={true}
              height="100"
              width="100"
              ariaLabel="dna-loading"
            />
            }/>
      </Box>
           
    </Box>
    
  
     <BootstrapDialog open={isShowAdd} onClose={initModalAdd}>
     <BootstrapDialogTitle onClose={initModalAdd}>
          Inserisci una prestazione
        </BootstrapDialogTitle>
        <Box
        component="form" 
        onSubmit={(e) => handleNewPrestazione(e)}>
          <DialogContent dividers>
            <Box sx={{width:450, display:'flex',flexDirection:'column',gap:'10px'}}>
            <FormControl fullWidth>
              <TextField label='Prestazione' id='prestazione' minLength='2' required/>
            </FormControl>
            <FormControl fullWidth>
              <TextField label='Traduzione Prestazione' id='prestazioneEN' minLength='2' required/>
            </FormControl>
            <label className="select-label">Specifica il tipo di prestazione:</label>
                <select label='Tipo' id='tipo' labelId="tipoLabel" className="select" required>
                {comboPrestazioni.map((prestazione) => (
                  <option key={prestazione.idCombo} value={prestazione.idCombo < 0 ? "" : prestazione.idCombo} >{prestazione.descrizione}</option>
                ))}
                </select>
            </Box>

          </DialogContent>
          <DialogActions>
            <Button variant='success' type='submit'>Inserisci Prestazione</Button>     
          </DialogActions> 
        </Box>
      </BootstrapDialog>   

      <BootstrapDialog open={isShow} onClose={handleClose} >      
        <BootstrapDialogTitle onClose={handleClose}>
          Modifica Prestazione
        </BootstrapDialogTitle>
        <Box
          component="form" onSubmit={(e) => handleModifyPrestazione(e)}>
          <DialogContent>
          <Box sx={{width:450, display:'flex',flexDirection:'column',gap:'10px'}}>
            <FormControl fullWidth>
              <TextField label='Prestazione' id='prestazioneMod' defaultValue={prestazioneSelected.descrizione} minLength='2' required/>
            </FormControl>
            <FormControl fullWidth>
              <TextField label='Traduzione Prestazione' id='prestazioneENMod' defaultValue={prestazioneSelected.descrizioneEN} minLength='2' required/>
            </FormControl>
            <label className="select-label">Specifica il tipo di prestazione:</label>
            <select className="select" label='Tipo' id='tipoMod' labelId="tipoLabel" defaultValue={selectedTipoMod} required>
                {comboPrestazioni.map((prestazione) => (
                  <option key={prestazione.idCombo} value={prestazione.idCombo < 0 ? "" : prestazione.idCombo} disabled={prestazione.idCombo <0 && "true"}>{prestazione.descrizione}</option>
                ))}
                </select>

            </Box>
          </DialogContent>
          <DialogActions>
            <Button variant='success' type='submit'>Salva Modifica</Button>     
          </DialogActions> 
        </Box>
      </BootstrapDialog>
      
    </Container>
    </>
  )
}

export default Prestazioni